export default function(inputGroup, suggestion = null) {
  // Return if does not have calculations
  let hasCalculations = inputGroup.attr('data-has-calculations');
  if (typeof hasCalculations === 'undefined' || hasCalculations !== 'true') {
    return;
  }
  // Set dependent question IDs (questions that should get updated based on this answer)
  let dependentQuestionIds = [];
  let determiningCalculations = inputGroup.attr('data-determining-calculations');
  if (typeof determiningCalculations === 'undefined') {
    return;
  } else {
    // Extract dependent question IDs from determining calculations
    determiningCalculations = JSON.parse(determiningCalculations);
    $.each(determiningCalculations, function(i, arr) {
      let dependentQuestionId = arr[2];
      if (!dependentQuestionIds.includes(dependentQuestionId)) {
        dependentQuestionIds.push(dependentQuestionId);
      }
    });
  }

  // For each dependent question, update its calculated value
  $.each(dependentQuestionIds, function(i, dependentQuestionId) {
    UpdateCalculatedQuestion(dependentQuestionId);
  });

}

function UpdateCalculatedQuestion(dependentQuestionId) {

  // Set all determining calculations tied to the same dependent question
  let determiningCalculations = [];
  $('.input-group[data-has-calculations=true][data-determining-calculations]').each(function() {
    let ig = $(this);
    let dc = ig.attr('data-determining-calculations');
    if (typeof dc === 'undefined') {
      return;
    }
    dc = JSON.parse(dc);
    for (let i = 0; i < dc.length; i++) {
      if (String(dc[i][2]) === String(dependentQuestionId)) {
        determiningCalculations.push({ inputGroup: ig, calculation: dc[i] });
      }
    }
  });

  // Set base calculated value
  let calculatedVal = 0;
  let targetInput = $('.question-row[data-question-id=\'' + dependentQuestionId + '\']').find('.answer-text');

  // Ensure every determining question has a value before attempting calculation
  let allAnswered = determiningCalculations.every(function(item) {
    let determiningAnswer = item.inputGroup.find('.answer-text').val();
    return typeof determiningAnswer !== 'undefined' && determiningAnswer !== '';
  });
  if (determiningCalculations.length > 0 && !allAnswered) {
    if (targetInput.length > 0) {
      targetInput.val('').trigger('change');
    }
    return;
  }

  // For each determining calculation, perform the calculation and update the calculated input
  determiningCalculations.forEach(function(item) {
    let ig = item.inputGroup;
    let arr = item.calculation;
    let operator = arr[1];
    let determiningAnswer = ig.find('.answer-text').val();

    // Next if no answer
    if (typeof determiningAnswer === 'undefined' || determiningAnswer === '') {
      return;
    }

    // Perform calculation based on operator
    if (operator === 'Add') {
      calculatedVal += parseFloat(determiningAnswer);
    } else if (operator === 'Subtract') {
      calculatedVal -= parseFloat(determiningAnswer);
    } else if (operator === 'Multiply') {
      // If .answer-text field has class percent-field, divide by 100
      if (ig.find('.answer-text').hasClass('percent-field')) {
        determiningAnswer = parseFloat(determiningAnswer) / 100;
      }
      calculatedVal *= parseFloat(determiningAnswer);
    } else if (operator === 'Divide') {
      if (parseFloat(determiningAnswer) !== 0) {
        calculatedVal /= parseFloat(determiningAnswer);
      }
    } else {
      calculatedVal += parseFloat(determiningAnswer); // Default to add
    }
  });

  // Remove unnecessary decimal places
  if (calculatedVal % 1 === 0) {
    calculatedVal = parseInt(calculatedVal);
  } else {
    calculatedVal = parseFloat(calculatedVal.toFixed(2));
  }

  // Remove NaN or infinite values
  if (isNaN(calculatedVal) || !isFinite(calculatedVal)) {
    calculatedVal = '';
  }

  // Set the value of the target input
  if (targetInput.length > 0) {
    targetInput.val(calculatedVal).trigger('change');
  }

}
